import { uploadFile } from "#shared/infra/uploadFile.service";
import { FileTypeSchema } from "shared";

export const uploadPartFiles = async (
  files: {
    name: string;
    data: File;
    hash: string;
  }[],
  callback: (progress: number) => void,
): Promise<{ id: string; url: string; name: string; hash: string; size: number }[]> => {
  const promises = files.map(async (file) => {
    const { id, fileUrl } = await uploadFile({
      file: file.data,
      type: FileTypeSchema.enum.PART,
      isUserConnected: true,
      callback: (progress) => {
        callback(progress / files.length);
      },
    });

    return {
      id,
      url: fileUrl,
      name: file.name,
      hash: file.hash,
      size: file.data.size,
    };
  });

  const uploadedFiles = await Promise.all(promises);

  return uploadedFiles;
};
